import React from "react";
import { Link } from "react-router-dom";
import MnLink from "./atoms/MnLink";
import HeadingText from "./atoms/HeadingText";
import ParaText from "./atoms/ParaText";

function CourseCard({ title, topics, imageUrl, courseLink }) {
  return (
    <Link
      to={courseLink}
      className="block transform transition duration-300 ease-in-out hover:scale-105"
    >
      <div className="bg-white border border-gray-300 overflow-hidden hover:border-gray-400 relative">
        <div className="relative w-full h-72">
          <img
            className="w-full h-full object-cover absolute inset-0"
            src={imageUrl}
            alt={title}
          />
          <div className="absolute inset-0 bg-primary/10"></div>
        </div>
        <div className="flex flex-col items-center justify-center px-6 py-4 text-center">
          <HeadingText variant="h3">{title}</HeadingText>
          <div className="h-28">
            {topics.map((topic, index) => (
              <ParaText key={index}>{topic}</ParaText>
            ))}
          </div>

          <div className="mt-6">
            <MnLink to={`/${courseLink}`} name="Read More" />
          </div>
        </div>
      </div>
    </Link>
  );
}

export default CourseCard;
